import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page-compaign-coca-cola" }

import { IProgram } from '@/types/program';
  import Collapse from './components/collapse/index-view.vue';
  import Page1 from './components/page-1/index-view.vue';
  import Page2 from './components/page-2/index-view.vue';
  import Page3 from './components/page-3/index-view.vue';
  import Page4 from './components/page-4/index-view.vue';
  import Page5 from './components/page-5/index-view.vue';
  import Page6 from './components/page-6/index-view.vue';
  import Faq from './components/faq/index-view.vue';
  import Footer from './components/footer/index-view.vue';

  export interface IProps {
    program: IProgram
  }
export default /*#__PURE__*/_defineComponent({
  props: {
    program: { default: () => ({} as IProgram) }
  },
  setup(__props: any) {

  ;

  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Page1),
    _createVNode(Page2, { program: __props.program }, null, 8, ["program"]),
    _createVNode(Collapse, { title: "캠페인 참여 방법" }, {
      default: _withCtx(() => [
        _createVNode(Page3)
      ]),
      _: 1
    }),
    _createVNode(Collapse, { title: "원더플 피플을 위한 리워드" }, {
      default: _withCtx(() => [
        _createVNode(Page4)
      ]),
      _: 1
    }),
    _createVNode(Collapse, { title: "올바른 분리배출 방법" }, {
      default: _withCtx(() => [
        _createVNode(Page5)
      ]),
      _: 1
    }),
    _createVNode(Collapse, { title: "재활용 공정 프로세스" }, {
      default: _withCtx(() => [
        _createVNode(Page6)
      ]),
      _: 1
    }),
    _createVNode(Collapse, { title: "FAQ" }, {
      default: _withCtx(() => [
        _createVNode(Faq)
      ]),
      _: 1
    }),
    _createVNode(Footer)
  ]))
}
}

})